/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-basic-rack': {
    width: 100,
    height: 60.352,
    viewBox: '0 0 26.458 15.968',
    data: '<path pid="0" d="M24.21 0h-2.778l-2.249 6.825h-2.316L14.618 0H11.84L9.592 6.825H7.275L5.026 0H2.25L0 6.825v9.143h26.458V6.825z"/>'
  }
})
